import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import userManagementReducer from "./slices/usersManagement";
import userReducer from "./slices/userData";
import ribbonsTransactionListReducer from "./slices/ribbionsTransactionSlice";

export const store = configureStore({
  reducer: {
    userManagement: userManagementReducer,
    userData: userReducer,
    ribbonsTransactionList: ribbonsTransactionListReducer
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
